/* eslint-disable camelcase */
import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'

const PageConst = {
  ACTION: {
  },
  m0040List: [
    // { time_limit_no: '11', time_division: '1', time_limit_name: '1講（前半）' , start_time: '09:00', end_time: '09:40' },
    // { time_limit_no: '12', time_division: '2', time_limit_name: '1講（後半）' , start_time: '09:50', end_time: '10:30' },
    // { time_limit_no: '21', time_division: '1', time_limit_name: '2講（前半）' , start_time: '10:40', end_time: '11:20' },
    // { time_limit_no: '22', time_division: '2', time_limit_name: '2講（後半）' , start_time: '11:30', end_time: '12:10' },
    // { time_limit_no: '31', time_division: '1', time_limit_name: '3講（前半）' , start_time: '13:10', end_time: '13:50' },
    // { time_limit_no: '32', time_division: '2', time_limit_name: '3講（後半）' , start_time: '14:00', end_time: '14:40' },
    // { time_limit_no: '41', time_division: '1', time_limit_name: '4講（前半）' , start_time: '14:50', end_time: '15:30' },
    // { time_limit_no: '42', time_division: '2', time_limit_name: '4講（後半）' , start_time: '15:40', end_time: '16:20' },
    // { time_limit_no: '51', time_division: '1', time_limit_name: '5講（前半）' , start_time: '16:40', end_time: '17:10' },
    // { time_limit_no: '52', time_division: '2', time_limit_name: '5講（後半）' , start_time: '17:20', end_time: '18:10' },
    // { time_limit_no: '61', time_division: '1', time_limit_name: '6講（前半）' , start_time: '18:20', end_time: '19:00' },
    // { time_limit_no: '62', time_division: '2', time_limit_name: '6講（後半）' , start_time: '19:10', end_time: '19:50' },
    // { time_limit_no: '71', time_division: '1', time_limit_name: '7講（前半）' , start_time: '20:00', end_time: '20:40' },
    // { time_limit_no: '72', time_division: '2', time_limit_name: '7講（後半）' , start_time: '20:50', end_time: '21:30' }
  ],
  insertSchedule: [],
  m0110Center: [],
  scheduleList: [],
  selectedCenter: null,
  selectedTeacher: null,
  teacherList: [],
  isTableLoad: false,
}

const module = {
  state: {
    PageConst,

    isEditableMap: {},

    // set default here
    searchInfo:{
      schedule_date : null,
      center_no: null,
      teacher_no: null,
    },
    pagination: {
      current_page: 1,
      per_page: 10
    },
    // set default here

    // orderBy:PageConst.SEARCH_DEF.sortDef[0].value,
    selectedLesson: null,
    cellValueKey: null // use to detect cell value change
  },

  getters: {
    find_schedule: (state) => (schedule) =>{
      return state.PageConst.insertSchedule.some(
        (item) =>
          item.time_limit_no.toString() === schedule.time_limit_no.toString() &&
          item.schedule_datetime === schedule.schedule_datetime &&
          item.time_division === schedule.time_division &&
          item.center_no === schedule.center_no &&
          item.dayofweek_code === schedule.dayofweek_code
      );
    },
    find_scheduleByProperty: (state) => (criteria) => {
      return state.PageConst.insertSchedule.find(item =>
        Object.keys(criteria).every(key => item[key] === criteria[key])
      );
    },
    compareSchedule: (state) => (compareInfo) => {

      let result = false;
      if (compareInfo.schedule1 !== undefined && compareInfo.schedule2 !== undefined) {
        result = compareInfo.key.find(prop => compareInfo.schedule1[prop] === compareInfo.schedule2[prop]) != null;
        result = result === undefined ? false : result;
      }

      return result;
    },
    getScheduleList: (state) => {
      return state.PageConst.scheduleList;
    },
    getInsertScheduleCount: (state) => {
      return state.PageConst.insertSchedule.length;
    },
    getTeacherList: (state) => {
      return state.PageConst.teacherList
    },
    getSelectedCenter: (state) => {
      return state.PageConst.selectedCenter;
    },
    getSelectedTeacher: (state) => {
      return state.PageConst.selectedTeacher;
    },
    getEditable: (state) => {
      return ({date, time_limit_no,isTeacher}) => {
        // check date is YYYY-MM-DD, use moment
        const target = state.isEditableMap[date + ','+time_limit_no];
        if(!target){
          console.log('no target:', date + ','+time_limit_no)
        }
        if(isTeacher){
          // switch (target.is_teacher_editable){
          //   case 'noOpen_today':
          //   case 'noOpen_timeLimit':
          //   case 'cannotEdit_alreadyStart':
          //   case 'cannotEdit_teacherCannotModifyToday':
          //   case 'cannotEdit_teacherDecisionTimeOut':
          //   case 'canEdit:
          // }
        } else{
          // switch (target.is_admin_editable){
          //   case 'noOpen_today':
          //   case 'noOpen_timeLimit':
          //   case 'cannotEdit_alreadyStart':
          //   case 'canEdit:
          // }
        }
        return isTeacher ? target.is_teacher_editable : target.is_admin_editable;
      }
    },
    getT3010:(state) => {
      return ({date, time_limit_no}) => {
        // check date is YYYY-MM-DD, use moment
        const target = state.isEditableMap[date + ','+time_limit_no];
        if(!target){
          console.log('no target:', date + ','+time_limit_no)
        }

        return target.t3010_ids
      }
    },
  },
  mutations: {
    updateOrCreateSchedule(state, data){
      const {schedule_date,time_limit_no,work_flag,delete_flag} = data

      const schedule = state.PageConst.insertSchedule.find(item =>
        item.schedule_date === schedule_date
        && item.time_limit_no === time_limit_no
      );
      if (schedule) {
        schedule.work_flag = work_flag;
        schedule.delete_flag = delete_flag;
      } else {
        state.PageConst.insertSchedule.push({
          teacher_no: state.searchInfo.teacher_no,
          center_no: state.searchInfo.center_no,
          ...data
        });
      }
    },
    setM0110Center(state, data) {
      state.PageConst.m0110Center = data;
    },
    setPageConst(state, data) {
      state.PageConst[data.key] = data.value;
    },
    setTeacherList(state, data) {
      state.PageConst.teacherList = data;
    },
    clearInsertSchedule(state) {
      state.PageConst.insertSchedule = [];
    },
    setIsTableLoad(state, data) {
      state.PageConst.isTableLoad = data;
    },
    setcellValueKey(state, data) {
      state.cellValueKey = data;
    }
  },
  actions: {
    C10201_clear({state}){
      state.PageConst.insertSchedule = [];
      state.PageConst.scheduleList = [];
      state.PageConst.selectedCenter = null;
      state.PageConst.selectedTeacher = null;
      state.searchInfo = {
        schedule_date : null,
        center_no: null,
        teacher_no: null,
      }
    },
    async doBrowseAllByCalendar({ state, commit }, payload) {
      const data = {
        scheduleList: {
          api: 'T2040TeacherScheduleService.doBrowseAllByCalendar',
          input: {
            searchInfo: state.searchInfo
          }
        },
        isEditableMap: {
          api: 'T2040TeacherScheduleService.C10201_checkIsEditable',
          input: {
            searchInfo: state.searchInfo
          }
        }
      }
      if (payload?.getInitData) {
        data.m0040List = {
          api: 'M0040TimeLimitService.doBrowseAll',
          input: {
            searchInfo: {
              not_time_division: 0
            }
          }
        }
        // If is admin, no need get scheduleList and isEditableMap on init
        if (window.vue.$store.getters['Auth/isAdmin']) {
          delete data.scheduleList
          delete data.isEditableMap
        }
      }
      return await ApiUtils.postData({
        data
      }).then((data) => {
        commit('setState',{
          PageConst: {
            ...state.PageConst,
            scheduleList: data.scheduleList?.output ?? state.PageConst.scheduleList,
            m0040List: data.m0040List?.output ?? state.PageConst.m0040List,
          },
          isEditableMap: data.isEditableMap?.output ?? state.isEditableMap
        })
      })
    },
    async doUpdateSchedule({ state, commit }) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T2040TeacherScheduleService.doUpdateSchedule',
            input: {
              updateData: state.PageConst.insertSchedule
            }
          }
        ]
      }).then((data) => {
        return data;
      })
    },
    async doBrowseTeacherByCenter({ state, commit }) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T2040TeacherScheduleService.doBrowseTeacherByCenter',
            input: {
              center_no : state.searchInfo.center_no,
            }
          }
        ]
      }, false).then((data) => {
        commit('setTeacherList', data[0].output)
      })
    },

  }
}


export default ObjArrUtils.merge(Base, module)
